import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, DatePicker, AutoComplete, InputNumber, Switch, Modal, Input, Tag, Empty, Button, message } from "antd";
import { CarOutlined, StopOutlined } from "@ant-design/icons";
import moment from "moment";
import { FormItem, DynamicCardForm, ButtonItem, SelectEmpleadosItem, TextAreaItem, InputItem } from "../../../../Components/Items";
import ModalFormCMMS from "../componentes/ModalFormCMMS";
import UnidadesViajeCMMS from "./UnidadesViajeCMMS";
import { cmmsPost, fechaDiaPayload, momentFechaDia, formatoFecha, estatusServicio } from "../cmmsComun";

const { RangePicker } = DatePicker;
const mismoTexto = (a, b) => String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();

// Alta / edicion de un viaje (renglon del C-LO-01: municipio, unidad, vehiculo y personal).
// props: visible, viajeId (editar) o fechaInicial (moment, nuevo), empleadoInicial,
// opciones { vehiculos, destinos }, onClose(huboCambio)
class ModalViajeCMMS extends Component {
    formRef = React.createRef();
    state = { loading: false, viaje: null, servicios: [], cancelar: null, dias: 1 };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) this.inicializar();
    }

    inicializar = async () => {
        this.formRef.current?.resetFields();
        this.setState({ viaje: null, servicios: [], cancelar: null });
        if (!this.props.viajeId) {
            const f = this.props.fechaInicial || moment();
            this.formRef.current?.setFieldsValue({ fechas: [f, f], empleadosIds: this.props.empleadoInicial ? [this.props.empleadoInicial] : [], unidades: [], cancelaComedor: false });
            this.setState({ dias: 1 });
            return;
        }
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "datosViajeCMMS", { id: this.props.viajeId });
            if (res.data.success !== 2) {
                message.error(res.data.message || "No se encontró el viaje");
                return this.props.onClose(false);
            }
            const v = res.data.viaje;
            this.setState({ viaje: v, servicios: res.data.servicios || [], dias: v.dias || 1 });
            this.formRef.current?.setFieldsValue({
                fechas: [momentFechaDia(moment, v.fechaInicio), momentFechaDia(moment, v.fechaFin)],
                destino: v.destino,
                km: v.km || undefined,
                empleadosIds: (v.empleadosIds || []).map(String),
                vehiculo: v.vehiculoNombre || "",
                unidades: (v.unidades || []).map((u) => ({ clienteId: u.clienteId, direccionId: u.direccionId })),
                unidadesTexto: v.unidadesTexto,
                cancelaComedor: !!v.cancelaComedor,
                notas: v.notas,
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    payload = (values) => {
        const vehiculo = (this.props.opciones?.vehiculos || []).find((x) => mismoTexto(x.nombre, values.vehiculo));
        return {
            id: this.props.viajeId,
            fechaInicio: fechaDiaPayload(values.fechas?.[0]),
            fechaFin: fechaDiaPayload(values.fechas?.[1]),
            destino: values.destino || "",
            km: values.km,
            empleadosIds: values.empleadosIds || [],
            vehiculoId: vehiculo?._id || null,
            vehiculoTexto: vehiculo ? "" : values.vehiculo || "",
            unidades: (values.unidades || []).filter((u) => u.clienteId),
            unidadesTexto: values.unidadesTexto || "",
            cancelaComedor: !!values.cancelaComedor,
            notas: values.notas || "",
        };
    };

    guardar = async (payload, confirmar = false) => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, this.props.viajeId ? "editarViajeCMMS" : "agregarViajeCMMS", { ...payload, confirmar });
            if (res.data.success === 3)
                return Modal.confirm({
                    title: "Se cruza con otros viajes",
                    content: <div style={{ whiteSpace: "pre-wrap" }}>{res.data.message}</div>,
                    okText: "Guardar de todos modos",
                    cancelText: "Regresar",
                    onOk: () => this.guardar(payload, true),
                });
            if (res.data.success !== 2) return message.error(res.data.message || "No se pudo guardar el viaje");
            message.success(this.props.viajeId ? "Viaje actualizado" : `Viaje ${res.data.folio} registrado`);
            this.props.onClose(true);
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar el viaje");
        } finally {
            this.setState({ loading: false });
        }
    };

    cancelarViaje = async () => {
        const motivo = String(this.state.cancelar || "").trim();
        if (!motivo) return message.error("Escriba el motivo de la cancelación");
        const res = await cmmsPost(this.props, "cancelarViajeCMMS", { id: this.props.viajeId, motivo });
        if (res.data.success !== 2) return message.error(res.data.message || "No se pudo cancelar");
        message.success("Viaje cancelado");
        this.setState({ cancelar: null });
        this.props.onClose(true);
    };

    // Al elegir un destino conocido se proponen sus km (ida y vuelta).
    elegirDestino = (nombre) => {
        const d = (this.props.opciones?.destinos || []).find((x) => mismoTexto(x.nombre, nombre));
        if (d?.km > 0) this.formRef.current?.setFieldsValue({ km: d.km });
    };

    onValuesChange = (cambios) => {
        if (cambios.fechas?.[0] && cambios.fechas?.[1]) this.setState({ dias: cambios.fechas[1].clone().startOf("day").diff(cambios.fechas[0].clone().startOf("day"), "days") + 1 });
    };

    renderServicios() {
        const { servicios } = this.state;
        return (
            <DynamicCardForm title={`Servicios en este viaje (${servicios.length})`} xs={24}>
                <div className="cmms-ayuda">Órdenes de Servicio de las personas del viaje en esas fechas.</div>
                {servicios.length ? (
                    servicios.map((s) => (
                        <div key={s._id} style={{ display: "flex", justifyContent: "space-between", gap: 8, padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}>
                            <Button
                                type="link"
                                size="small"
                                style={{ padding: 0, height: "auto", textAlign: "left", whiteSpace: "normal" }}
                                onClick={() => {
                                    this.props.onClose(false);
                                    this.props.history.push("/panel/cmmsServicio", { id: s._id });
                                }}
                            >
                                {s.codigo} · {formatoFecha(s.fecha)} · {[s.activoTexto, s.clienteNombre].filter(Boolean).join(" · ")}
                            </Button>
                            <Tag color={estatusServicio(s.estatus).color}>{s.estatusNombre}</Tag>
                        </div>
                    ))
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Todavía no hay servicios en esas fechas" />
                )}
            </DynamicCardForm>
        );
    }

    render() {
        const v = this.state.viaje;
        const opciones = this.props.opciones || {};
        const editar = !!this.props.viajeId;
        return (
            <>
                <ModalFormCMMS
                    titulo={editar ? `Viaje ${v?.codigo || ""}` : "Nuevo viaje"}
                    subtitulo="A dónde se va, qué unidades se visitan, en qué vehículo y quiénes."
                    icono={<CarOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />}
                    visible={this.props.visible}
                    loading={this.state.loading}
                    onCancel={() => this.props.onClose(false)}
                    formRef={this.formRef}
                    name="viajeCMMS"
                    onFinish={(values) => this.guardar(this.payload(values))}
                    onValuesChange={this.onValuesChange}
                    textoGuardar={editar ? "Guardar cambios" : "Registrar viaje"}
                    accionesPie={
                        editar && v?.estatus === 1 ? (
                            <ButtonItem rojoB htmlType="button" lessTime icon={<StopOutlined />} onClick={() => this.setState({ cancelar: "" })}>
                                Cancelar viaje
                            </ButtonItem>
                        ) : null
                    }
                    width={860}
                >
                    <DynamicCardForm title="Viaje" xs={24} lg={12}>
                        <FormItem label={`Salida y regreso${this.state.dias > 1 ? ` (${this.state.dias} días)` : ""}`} name="fechas" required tooltip="Un viaje de un solo día lleva la misma fecha de salida y regreso.">
                            <RangePicker format="DD/MM/YYYY" style={{ width: "100%" }} allowClear={false} />
                        </FormItem>
                        <FormItem label="Destino (municipio o ciudad)" name="destino" tooltip="Los destinos se recuerdan con sus km: la próxima vez se proponen solos.">
                            <AutoComplete
                                placeholder="Ej. RIOVERDE, EDO MEX"
                                maxLength={80}
                                options={(opciones.destinos || []).map((d) => ({ value: d.nombre, label: d.km ? `${d.nombre} · ${d.km.toLocaleString("es-MX")} km` : d.nombre }))}
                                filterOption={(input, o) => String(o.value).toLowerCase().includes(input.toLowerCase())}
                                onSelect={this.elegirDestino}
                            />
                        </FormItem>
                        <Row gutter={12}>
                            <Col xs={12}>
                                <FormItem label="Km (ida y vuelta)" name="km">
                                    <InputNumber min={0} max={20000} style={{ width: "100%" }} placeholder="0" formatter={(x) => (x ? `${x}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")} parser={(x) => x.replace(/,/g, "")} />
                                </FormItem>
                            </Col>
                            <Col xs={12}>
                                <FormItem label="Cancela comedor" name="cancelaComedor" valuePropName="checked" tooltip="En amarillo en el calendario: esos días no comen en la oficina.">
                                    <Switch />
                                </FormItem>
                            </Col>
                        </Row>
                    </DynamicCardForm>
                    <DynamicCardForm title="Quiénes y en qué" xs={24} lg={12}>
                        <FormItem label="Personal" name="empleadosIds" required>
                            <SelectEmpleadosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} width="100%" mode="multiple" placeholder="Ingenieros que viajan" />
                        </FormItem>
                        <FormItem label="Vehículo" name="vehiculo" tooltip="Los vehículos dados de alta en el ERP (Vehículos). Si no está, escriba su nombre.">
                            <AutoComplete
                                placeholder="Ej. Kia Forte Gris"
                                maxLength={80}
                                options={(opciones.vehiculos || []).map((x) => ({ value: x.nombre, label: x.detalle ? `${x.nombre} · ${x.detalle}` : x.nombre }))}
                                filterOption={(input, o) => String(o.label).toLowerCase().includes(input.toLowerCase())}
                            />
                        </FormItem>
                    </DynamicCardForm>
                    <DynamicCardForm title="Unidades que se visitan" xs={24}>
                        <FormItem name="unidades" noStyle>
                            <UnidadesViajeCMMS empresaId={this.props.empresaId} headersToken={this.props.headersToken} />
                        </FormItem>
                        <FormItem label="Otras unidades" name="unidadesTexto" max={200} style={{ marginTop: 10 }}>
                            <InputItem placeholder='Lo que no es cliente o varias a la vez (ej. "VARIOS", "DRA. BRENDA")' />
                        </FormItem>
                        <FormItem label="Notas" name="notas">
                            <TextAreaItem rows={2} placeholder="Opcional" />
                        </FormItem>
                    </DynamicCardForm>
                    {editar && this.renderServicios()}
                </ModalFormCMMS>
                <Modal
                    visible={this.state.cancelar !== null}
                    title="Cancelar viaje"
                    onCancel={() => this.setState({ cancelar: null })}
                    onOk={this.cancelarViaje}
                    okText="Cancelar viaje"
                    cancelText="Regresar"
                    okButtonProps={{ danger: true }}
                >
                    <Input.TextArea rows={3} placeholder="Motivo (obligatorio)" value={this.state.cancelar || ""} onChange={(e) => this.setState({ cancelar: e.target.value })} />
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ModalViajeCMMS));
